import { render } from "./RegisterForm.vue?vue&type=template&id=79c490a2&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=79c490a2&scoped=true&lang=css"
import "./RegisterForm.vue?vue&type=style&index=1&id=79c490a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c490a2"]])

export default __exports__